import { rules } from "./rules"

export default {
 	rules
}
